<div *ngIf="!loader" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle"
     aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content" style="border: none !important;">
            <div class="modal-header">
                <h2 class="modal-title" id="exampleModalLongTitle">{{modalTitle}}</h2>

            </div>
            <div class="modal-body">
                <div class="container-fluid">
                    <form [formGroup]="form">
                        <div class="row mb-3">
                            <label class="col-sm-4 col-form-label">Naziv* </label>
                            <div class="col-sm-8">
                                <input  pattern="\S+.*" type="text" formControlName="name" class="form-control"
                                       placeholder="Unesite naziv sprinta">
                                <div *ngIf="!form.get('name').valid">
                                    <span class="text-danger"> Ovo polje je obavezno.</span>
                                </div>
                            </div>
                        </div>
                        <div class="row mb-3">
                            <label class="col-sm-4 col-form-label">Sprint Goal</label>
                            <div class="col-sm-8">
                                <textarea formControlName="sprintGoal"
                                          class="form-control"></textarea>

                            </div>

                        </div>
                        <div class="row mb-3">
                            <label class="col-sm-4 col-form-label">Datum početka* </label>
                            <div class="col-sm-8">
                                <input
                                        class="form-control"
                                        placeholder="Izaberite datum"
                                        name="dp"
                                        (click)="dateStart.toggle()"
                                        formControlName="dateStart"
                                        ngbDatepicker #dateStart="ngbDatepicker">
                                <div *ngIf="form.get('dateStart').invalid">
                                    <span class="text-danger"> Ovo polje je obavezno.</span>
                                </div>
                            </div>

                        </div>
                        <div class="row mb-3">
                            <label class="col-sm-4 col-form-label">Datum završetka*</label>
                            <div class="col-sm-8">
                                <input
                                        class="form-control"
                                        placeholder="Izaberite datum"
                                        name="dp"
                                        (click)="dateEnd.toggle()"
                                        formControlName="dateEnd"
                                        ngbDatepicker #dateEnd="ngbDatepicker">
                                <div *ngIf="form.get('dateEnd').invalid">
                                    <span class="text-danger"> Ovo polje je obavezno.</span>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <div class="modal-footer">
                <button (click)="closeModal()" type="button" class="btn btn-light" data-dismiss="modal">Zatvori
                </button>
                <button (click)="saveData()" type="button" class="btn btn-primary">Sačuvaj</button>
            </div>
        </div>
    </div>
</div>



